module.exports = __webpack_public_path__ + "img/samuel-smc.e1857e69.jpg";